export enum possibleAthleteInfoStatus {
    idle = 'idle',
    loading = 'loading',
    succeeded = 'succeeded',
    failed = 'failed',
}

export type AthleteDataType = {
    id: string,
    name: string
}